<script setup lang="ts">
    const props = defineProps<{ blok: FooterLinkStoryblok }>();
</script>

<template>
    <div v-editable="props.blok">
        <NuxtLink
            :to="useStoryblokUrl(props.blok.link)"
            class="footer-link"
            data-testid="footer-link"
            :target="props.blok.External || props.blok.link?.target === '_blank' ? '_blank' : ''"
        >
            <img
                v-if="props.blok.Icon?.id"
                :src="props.blok.Icon.filename || props.blok.Icon.src || undefined"
                :alt="props.blok.Icon.alt ?? ''"
                class="footer-icon"
                loading="lazy"
            />
            <span>
                {{ props.blok.name }}
            </span>
        </NuxtLink>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/footer/footer-link.scss';
</style>
